export class MenuItemCatalogPriceModel {
  id: number;
  menu_item_id: number;
  menu_item_catalog_id: number;
  price: number;
  size: string;
  activate_offer: boolean;
  offer_price: number;
  offer_title: string;
  currency_code: string;
  is_modifier: boolean;

  constructor(id = 0,
              menu_item_id = 0,
              menu_item_catalog_id = 0,
              price = 0,
              size = '',
              activate_offer = false,
              offer_price = 0,
              offer_title = '',
              currency_code = '') {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.menu_item_catalog_id = menu_item_catalog_id;
    this.price = price;
    this.size = size;
    this.activate_offer = activate_offer;
    this.offer_price = offer_price;
    this.offer_title = offer_title;
    this.currency_code = currency_code;
  }
}
